import { convertDate, sortHashtags } from "helpers";
import { useClickAndView } from "hooks";
import { PersonDetailsContext } from "pages/PersonDetails";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { Magazine } from "types";
import Badge from "./Badge";
import Button from "./Button";
import Image from "./Image";

type Props = {
  article: Magazine.ArticleItem;
};

export default function ArticleCard({ article }: Props) {
  const { user } = useContext(PersonDetailsContext);
  const [clickAndView] = useClickAndView({
    contentId: article.id,
    variant: "article",
    click: false,
  });
  return (
    <article className="w-full py-1 px-5">
      <h3 className="text-sm font-medium text-dark py-1">{article.title}</h3>
      <div className="w-full py-1">
        <Image
          src={article.photo?.url}
          alt={article.title}
          className="w-full aspect-image rounded object-cover"
        />
      </div>
      <div className="flex flex-wrap gap-1 py-1 empty:hidden">
        {sortHashtags(article.hashtag)?.map((e) => (
          <Badge key={e}>#{e}</Badge>
        ))}
      </div>
      <p className="text-xs font-medium text-[#9A9EB1] py-1 empty:hidden">
        {convertDate(article.creationTime, "full-date")}
      </p>
      <div className="flex justify-end py-2.5">
        <Button
          as={Link}
          to={{
            pathname: "article-details",
            search: `articleId=${article.id}&userId=${user.id}`,
          }}
          type="button"
          variant="outline"
          color="dark"
          onClick={clickAndView}
        >
          Read More
        </Button>
      </div>
      <div className="w-full h-2.5 flex items-center">
        <hr className="border-[#ECEFF2] w-full" />
      </div>
    </article>
  );
}
